import { render, staticRenderFns } from "./value-card-edit.vue?vue&type=template&id=629ba08b&scoped=true&"
import script from "./value-card-edit.vue?vue&type=script&lang=ts&"
export * from "./value-card-edit.vue?vue&type=script&lang=ts&"
import style0 from "./value-card-edit.vue?vue&type=style&index=0&id=629ba08b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ba08b",
  null
  
)

export default component.exports